<div class="mini w-100 p-0 m-0 border-0 text-left {{type}}" [ngClass]="{'mini-sq': square}">
	<button class="mini-card w-100" (click)="launch()">
		<div class="card-title" [ngClass]="{ngss: mini?.NgssFlag}">
			<div class="triangle" *ngIf="mini?.NgssFlag"><div class="ngssTag"><span class="sr-only">NGSS</span></div></div>
			<div class="text" [innerHtml]="mini?.title"></div>
		</div>
		<div class="image">
			<img [src]="mini?.thumbnail?.url" [attr.alt]="mini?.title" />
			<div class="tag" *ngIf="mini?.CardTopic?.title">{{ mini?.CardTopic?.title }}</div>
		</div>
	</button>
</div>
